import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { keycloak } from '../keycloak';
import { CreatePreferenceRequest, FindAllPreferencesResponse } from './dto';

export const preferencesApi = createApi({
    reducerPath: 'preferencesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api',
        prepareHeaders: (headers, { getState }) => {
            if (keycloak.token) {
                headers.set('authorization', `Bearer ${keycloak.token}`);
            }
            headers.set('content-type', 'application/json');
            return headers;
        },
    }),
    tagTypes: ['Preferences'],
    endpoints: (builder) => ({
        findAllPreferences: builder.query<FindAllPreferencesResponse, string>({
            query: (owner) => `preferences?owner=${owner}`,
            providesTags: ['Preferences'],
        }),

        createPreferences: builder.mutation<void, CreatePreferenceRequest>({
            query: (request) => ({
                url: 'preferences',
                method: 'POST',
                body: request,
            }),
            invalidatesTags: ['Preferences'],
        }),

        updatePreferences: builder.mutation<void, { data: CreatePreferenceRequest; id: string }>({
            query: ({ data, id }) => ({
                url: `preferences/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Preferences'],
        }),
    }),
});

export const {
    useFindAllPreferencesQuery,
    useCreatePreferencesMutation,
    useUpdatePreferencesMutation,
} = preferencesApi;
